<template>
  <v-dialog v-if="ready && value" v-model="value" persistent scrollable max-width="1024">
    <v-card>
      <v-card-title>新建样品设置方案</v-card-title>
      <v-card-text>
        <v-row>
          <!-- 样品设置方案名称 -->
          <v-col cols="4">
            <v-text-field label="请输入样品设置方案名称" v-model="schemaName" outlined dense hide-details></v-text-field>
          </v-col>

          <!-- 编辑样品名称 -->
          <v-col cols="12">
            <h3 class="mb-4">编辑样品名称</h3>
            <table-editor v-model="sampleSelectedRows" :header="sampleHeader" :items="sampleItems" :select-mode="sampleSelectMode" :row-check="onSampleTableRowCheck" :row-check-all="onSampleTableRowCheckAll"></table-editor>
          </v-col>

          <!-- 设置样品分组 -->
          <v-col cols="12" v-if="groupMulti">
            <h3>设置样品分组</h3>
            <v-row>
              <v-col :cols="col" v-for="(group,i) in groupList" :key="`group_${i}`">
                <v-card outlined class="rounded-0">
                  <v-card-title>
                    <mini-text-editor v-if="i==groupEditIndex" v-model="group.newName" placeholder="分组名称(请勿输入非法字符)" :regex="EXP_ANALYSE_CONTENT"></mini-text-editor>
                    <template v-else>
                      {{group.name}}
                      <template v-if="groupEditIndex == -1">
                        <v-spacer />
                        <v-btn color="primary" text x-small @click="onEditGroup(i)">修改</v-btn>
                        <v-btn color="primary" text x-small @click="onRemoveGroup(i)">删除</v-btn>
                      </template>
                    </template>
                  </v-card-title>
                  <v-card-text>
                    <template v-if="i==groupEditIndex">
                      <v-chip-group v-model="groupSelectedRows" active-class="primary" column multiple>
                        <template v-for="(item,index) in sampleItems">
                          <v-chip small v-show="sampleSelectedRows.indexOf(index)!=-1 && groupSelectedSampleItems.indexOf(index)==-1" :key="item[1]">{{item[2]}}</v-chip>
                        </template>
                      </v-chip-group>
                    </template>
                    <template v-else>
                      <v-chip-group column>
                        <v-chip small disabled v-for="item in sampleItems.filter((s,idx)=>group.nos.indexOf(idx)!=-1)" :key="item[1]">{{item[2]}}</v-chip>
                      </v-chip-group>
                    </template>
                  </v-card-text>
                  <v-card-actions v-if="i==groupEditIndex">
                    <v-spacer />
                    <v-btn color="primary" text small @click="onAddGroupCancel(i)">取消</v-btn>
                    <v-btn color="primary" small @click="onAddGroupOk(i)">确定</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col :cols="col" v-if="groupEditIndex == -1">
                <v-icon x-large color="primary" @click="onAddGroup">mdi-plus</v-icon>
              </v-col>
            </v-row>
          </v-col>

          <!-- 设置比较组 -->
          <v-col cols="12">
            <h3>设置比较组</h3>
            <v-row>
              <v-col :cols="col" v-for="(groupVS,i) in groupVSList" :key="`groupVS_${i}`">
                <v-card outlined class="rounded-0">
                  <v-card-title>
                    <template v-if="groupVSEditIndex == i">
                      <v-radio-group v-if="groupMulti" row dense hide-details v-model="groupVSType">
                        <v-radio :value="1" label="两组比较"></v-radio>
                        <v-radio :value="2" label="多组比较（转录组测序不使用多组比较）"></v-radio>
                      </v-radio-group>
                    </template>
                    <template v-else>
                      <v-spacer />
                      <v-btn color="primary" text x-small @click="onEditGroupVS(i)">修改</v-btn>
                      <v-btn color="primary" text x-small @click="onRemoveGroupVS(i)">删除</v-btn>
                    </template>
                  </v-card-title>
                  <v-card-text>
                    <template v-if="groupVSEditIndex==i && groupVSType==1">
                      <v-row dense align="center" justify="center">
                        <v-col cols="5">
                          <div class="caption">分子组/实验组</div>
                          <mini-select-editor v-model="groupVSEditData[0]" required :items="groupList" item-value="name"></mini-select-editor>
                        </v-col>
                        <v-col cols="auto">
                          <h5 class="pt-6">VS</h5>
                        </v-col>
                        <v-col cols="5">
                          <div class="caption">分母组/对照组</div>
                          <mini-select-editor v-model="groupVSEditData[1]" required :items="groupList" item-value="name"></mini-select-editor>
                        </v-col>
                      </v-row>
                    </template>
                    <template v-else-if="groupVSEditIndex==i && groupVSType==2">
                      <v-chip-group v-model="groupVSSelectedRows" active-class="primary" column multiple>
                        <v-chip small v-for="item in groupList" :key="item.name">{{item.name}}</v-chip>
                      </v-chip-group>
                    </template>
                    <template v-else>
                      <v-row v-if="groupVS.length==2" dense align="center" justify="center">
                        <v-col cols="5" class="text-center">
                          <div class="caption">分子组/实验组</div>
                          {{groupVS[0]}}
                        </v-col>
                        <v-col cols="auto">
                          <h5 class="pt-6">VS</h5>
                        </v-col>
                        <v-col cols="5" class="text-center">
                          <div class="caption">分母组/对照组</div>
                          {{groupVS[1]}}
                        </v-col>
                      </v-row>
                      <v-chip-group v-else column>
                        <v-chip small disabled v-for="item in groupVS" :key="item">{{item}}</v-chip>
                      </v-chip-group>
                    </template>
                  </v-card-text>
                  <v-card-actions v-if="i==groupVSEditIndex">
                    <v-spacer />
                    <v-btn color="primary" text small @click="onAddGroupVSCancel(i)">取消</v-btn>
                    <v-btn color="primary" small @click="onAddGroupVSOk(i)">确定</v-btn>
                  </v-card-actions>
                </v-card>
              </v-col>
              <v-col :cols="col" v-if="groupVSEditIndex == -1">
                <v-icon x-large color="primary" @click="onAddGroupVS">mdi-plus</v-icon>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="primary" text @click="onCancel">取消</v-btn>
        <v-btn color="primary" @click="onOk">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
// 新建样品设置方案
import { userFileRead } from '@/plugins/api';
import { EXP_ANALYSE_CONTENT, chineseText2 } from '@/plugins/rules';
export default {
  props: ['value', 'type', 'xmh', 'report-data'],
  data () {
    return {
      EXP_ANALYSE_CONTENT: EXP_ANALYSE_CONTENT,
      chineseText2: chineseText2(),
      ready: false,
      col: 4,
      schemaName: null,
      sampleData: [],
      sampleSelectedRows: [],

      groupList: [],
      groupSelectedRows: [],
      groupEditIndex: -1,

      groupVSList: [],
      groupVSEditIndex: -1,
      groupVSType: 1,
      groupVSEditData: [],
      groupVSSelectedRows: []
    }
  },
  watch: {
    value (v) { if (v) this.init() }
  },
  // created () { this.init() },
  computed: {
    sampleHeader () {
      let row0 = this.sampleData[0], editName = this.reportData.optSampleEditName, ret = [];
      ret.push({ code: 0, name: row0[0] });
      ret.push({ code: 1, name: row0[1] });
      ret.push({ code: 2, name: row0[2], edit: editName, regex: EXP_ANALYSE_CONTENT });
      ret.push({ code: 4, name: row0[4], edit: true, regex: EXP_ANALYSE_CONTENT });
      return ret;
    },
    sampleSelectMode () { return this.reportData.optSampleSelect ? 2 : 0 },
    sampleItems () { return this.sampleData.slice(1) },
    groupSelectedSampleItems () {
      let ret = [];
      if (!this.groupList.length) return ret;
      this.groupList.forEach(group => {
        let nos = group.nos;
        if (nos && nos.length) nos.forEach(n => {
          if (ret.indexOf(n) == -1) ret.push(n);
        })
      })
      return ret;
    },
    groupMulti () { return this.reportData.optGroupMulti }
  },
  methods: {
    async init () {
      this.groupList = [];
      this.groupSelectedRows = [];
      this.groupEditIndex = -1;
      this.groupVSList = [];
      this.groupVSEditIndex = -1;
      this.groupVSType = 1;
      this.groupVSEditData = [];
      this.groupVSSelectedRows = [];
      await userFileRead({ path: `/${this.type}/${this.xmh}/Design/Schema/Sample.xlsx` }).then(res => this.sampleData = res.data)
      this.sampleSelectedRows = Array.from({ length: this.sampleData.length - 1 }).map((item, index) => index)
      if (this.optGroupMulti == false) {
        let groupNames = [];
        this.sampleData.slice(1).forEach(sd => {
          let groupName = sd[3];
          if (groupNames.indexOf(groupName) == -1) {
            groupNames.push(groupName);
            this.groupList.push({ name: groupName })
          }
        })
      }
      this.ready = true;
    },
    onSampleTableRowCheck (e, row, index) {
      let v1 = e.target.checked;
      if (!v1) { // 判断是否出现在样品分组中
        for (let i = 0; i < this.groupList.length; i++) {
          let exists = false;
          let nos = this.groupList[i].nos;
          if (nos && nos.length) {
            for (let m = 0; m < nos.length; m++) {
              if (nos[m] == index) {
                exists = true;
                break;
              }
            }
          }
          if (exists) {
            e.returnValue = false;
            this.$message.error('当前样品在样品分组中已存在，请先取消样品分组');
          }
        }
        let gsri = this.groupSelectedRows.indexOf(index);
        if (gsri != -1) this.groupSelectedRows.splice(gsri, 1)
      }
    },
    onSampleTableRowCheckAll (e) {
      let v1 = e.target.checked;
      if (!v1 && this.groupList.length) {
        e.returnValue = false;
        this.$message.error('请选取消样品分组');
      }
    },
    onCancel () { this.$emit('input', false) },
    onOk () {
      let vr = this.validate();
      if (vr) {
        this.$message.error(vr);
        return;
      }
      let schemaData = this.getSchemaData();
      this.$emit('ok', schemaData);
    },
    validate () {
      if (!this.schemaName) return '请输入样品设置方案名称';
      if(!this.chineseText2(this.schemaName)) return '样品设置方案名称只允许输入数字、字母、中文、下划线'
      if (!this.groupList.length) return '请设置样品分组';
      if (!this.groupVSList.length) return '请设置比较组';
    },
    getSchemaData () {// 获取样品设置方案的信息
      // 样品信息
      let sd = [];
      let row0 = this.sampleData[0];
      sd.push(row0);
      for (let i = 0; i < this.sampleItems.length; i++) {
        let item = this.sampleItems[i];
        let row = [item[0], item[1], item[2], this.optGroupMulti != false ? this.findGroupNames(i) : item[3], item[4] || ''];
        sd.push(row);
      }
      // 比较组信息
      let vsd = [['比较组']];
      for (let i = 0; i < this.groupVSList.length; i++) {
        let row = this.groupVSList[i];
        if (row.length == 2) vsd.push([row.join('_vs_')]);
        else vsd.push([row.join('_') + '_oneway']);
      }
      let path = `/${this.type}/${this.xmh}/Design/Schema_${this.schemaName}`;
      let ret = [
        { path: path, fileName: 'Sample.xlsx', content: sd.filter(r => r[3]) },
        { path: path, fileName: 'GroupVS.xlsx', content: vsd },
      ];
      return ret;
    },
    findGroupNames (index) {
      let ret = [];
      this.groupList.forEach(group => {
        if (group.nos.indexOf(index) != -1) ret.push(group.name)
      })
      return ret.join(';');
    },

    // ----------------- 样品分组
    onAddGroup () {
      this.groupEditIndex = this.groupList.length;
      this.groupList.push({ _state: 1 });
    },
    onAddGroupOk (index) {
      let group = this.groupList[index];
      let srcName = group.name;
      if (!group.newName) {
        this.$message.error('请输入分组名称');
        return;
      }
      if (!EXP_ANALYSE_CONTENT.test(group.newName)) {
        this.$message.error('分组名称格式输入有误，请勿输入非法字符');
        return;
      }
      if (!this.groupSelectedRows.length) {
        this.$message.error('请选择样品信息');
        return;
      }
      let sameItem = this.groupList.find((v, i) => i != index && v.name == group.newName);
      if (sameItem) {
        this.$message.error('分组名称已存在，请重新输入');
        return;
      }
      group._state = 2;
      group.name = group.newName;
      group.nos = this.groupSelectedRows;
      this.groupSelectedRows = [];
      this.groupEditIndex = -1;
      this.groupVSList.forEach(d => {
        if (d) {
          let idx = d.indexOf(srcName);
          if (idx != -1) d[idx] = group.name;
        }
      })
    },
    onAddGroupCancel (index) {
      let group = this.groupList[index];
      if (group._state == 1) this.groupList.splice(this.groupEditIndex, 1);
      this.groupSelectedRows = [];
      this.groupEditIndex = -1;
    },
    onEditGroup (index) {
      let group = this.groupList[index];
      group.newName = group.name;
      this.groupSelectedRows = group.nos;
      this.groupEditIndex = index;
    },
    onRemoveGroup (index) {
      let name = this.groupList[index].name;
      for (let i = 0; i < this.groupVSList.length; i++) {
        let d = this.groupVSList[i];
        let idx = d.indexOf(name);
        if (idx != -1) {
          this.$message.error('比较组中存在对当前样品分组的引用，请检查');
          return;
        }
      }
      this.groupList.splice(index, 1);
    },

    // -------------------- 比较组
    onAddGroupVS () {
      this.groupVSEditIndex = this.groupVSList.length;
      this.groupVSList.push({ _state: 1 });
    },
    onAddGroupVSCancel (index) {
      let groupVS = this.groupVSList[index];
      if (groupVS._state == 1) this.groupVSList.splice(this.groupVSEditIndex, 1);
      this.groupVSSelectedRows = [];
      this.groupVSEditIndex = -1;
      this.groupVSEditData = [];
    },
    onAddGroupVSOk () {
      if (this.groupVSType == 1) {
        let left = this.groupVSEditData[0];
        let right = this.groupVSEditData[1];
        if (!left || !right) {
          this.$message.error('请选择比较组');
          return;
        }
        if (left == right) {
          this.$message.error('请选择不同的样品分组');
          return;
        }
        let exists = this.groupVSList.find(d => d.length == 2 && d[0] == left && d[1] == right);
        if (exists) {
          this.$message.error('已存在相同设置的比较组，请检查');
          return;
        }
        this.groupVSList[this.groupVSEditIndex] = [left, right];
      } else {
        let ml = this.groupVSSelectedRows.length;
        if (ml < 3) {
          this.$message.error('请选择至少3个样品分组');
          return;
        }
        let exists = false;
        for (let i = 0; i < this.groupVSList.length; i++) {
          let d = this.groupVSList[i];
          if (d.length != ml) continue;
          let same = true;
          for (let m = 0; m < this.groupVSSelectedRows.length; m++) {
            if (d.indexOf(this.groupList[this.groupVSSelectedRows[m]].name) == -1) {
              same = false;
              break;
            }
          }
          if (same) {
            exists = true;
            break;
          }
        }
        if (exists) {
          this.$message.error('已存在相同设置的比较组，请检查');
          return;
        }
        let groupVS = [];
        for (let i = 0; i < ml; i++) groupVS.push(this.groupList[this.groupVSSelectedRows[i]].name)
        this.groupVSList[this.groupVSEditIndex] = groupVS;
      }
      this.groupVSSelectedRows = [];
      this.groupVSEditIndex = -1;
      this.groupVSEditData = [];
    },
    onEditGroupVS (index) {
      let d = this.groupVSList[index];
      if (d.length == 2) {
        this.groupVSEditData = d;
      } else {
        d.forEach(v => {
          let group = this.groupList.find(g => g.name == v);
          this.groupVSSelectedRows.push(this.groupList.indexOf(group))
        })
      }
      this.groupVSEditIndex = index;
    },
    onRemoveGroupVS (index) {
      this.groupVSList.splice(index, 1);
    }

  }
}
</script>